import { Injectable } from '@angular/core';
import { BaseSearchStrategy } from './base-strategy';
import { SearchableItem } from '../models/searchable-item.model';
import {
  ScoredMatch,
  StrategyContext,
  StrategyId,
} from '../models/search-strategy.model';

@Injectable({ providedIn: 'root' })
export class ExactMatchStrategy extends BaseSearchStrategy {
  readonly id: StrategyId = 'exact';
  readonly defaultWeight = 200;

  override score<T>(
    item: SearchableItem<T>,
    ctx: StrategyContext
  ): ScoredMatch | null {
    const q = ctx.normalizedQuery;
    if (this.normalizedTitle(item) === q) {
      return this.match(this.id, this.defaultWeight, 'title');
    }
    if (item.id.toLowerCase() === q) {
      return this.match(this.id, this.defaultWeight, 'id');
    }
    if (this.normalizedKeywords(item).some((k) => k === q)) {
      return this.match(this.id, this.defaultWeight, 'keyword');
    }
    return null;
  }
}
